import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import { BannerDetailFormikWrapper, BannerDetailForm } from './BannerDetailForm';

const BannerDetailFormModal = ({
  banner,
  title,
  confirmButtonText,
  cancelButtonText,
  open,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = async (values) => {
    try {
      await onSubmit(values);
      onClose();
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <BannerDetailFormikWrapper banner={banner} onSubmit={handleSubmit}>
      {(formikProps) => (
        <Dialog
          open={open}
          disableBackdropClick
          onClose={onClose}
          fullWidth={true}
          maxWidth={'md'}
          scroll={'paper'}
        >
          <DialogTitle>{title}</DialogTitle>
          <DialogContent dividers>
            <BannerDetailForm />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                formikProps.resetForm();
                onClose();
              }}
              disabled={formikProps.isSubmitting}
              type={'button'}
            >
              {cancelButtonText}
            </Button>
            <Button
              type={'submit'}
              onClick={formikProps.handleSubmit}
              color="primary"
              variant={'contained'}
              disabled={formikProps.isSubmitting || !formikProps.dirty || !formikProps.isValid}
            >
              {confirmButtonText}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </BannerDetailFormikWrapper>
  );
};
BannerDetailFormModal.defaultProps = {
  title: 'แก้ไขข้อมูล Banner',
  confirmButtonText: 'ยืนยันการแก้ไข',
  cancelButtonText: 'ยกเลิก',
};

export default BannerDetailFormModal;
